import React from 'react';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { useMerchant } from '@contexts/admin/MerchantContext';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';
import ListPageHeader from '@shared/ListPageHeader';
import MerchantInventoryTypesList from '@shared/merchant_inventory_types/MerchantInventoryTypesList';
import { Space, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { merchantInventoryTypeService } from '@services/admin/merchantInventoryTypeService';

function AdminMerchantInventoryTypesList() {
  const { t } = useTranslation();
  const { currentMerchant } = useMerchant();
  const { inventoryTypes } = useMerchantData();

  const helpTooltip = (
    <div>
      <div style={{ fontWeight: 'bold', marginBottom: 4 }}>
        {t('admin.pages.settings.merchant_inventory_types.help.title')}
      </div>
      <div style={{ marginBottom: 8 }}>
        {t('admin.pages.settings.merchant_inventory_types.help.description')}
      </div>
      <div style={{ fontSize: '12px', color: '#faad14' }}>
        {t('admin.pages.settings.merchant_inventory_types.help.note')}
      </div>
    </div>
  );

  const titleWithHelp = (
    <Space>
      {t('admin.menu.data.inventory_types')}
      <Tooltip title={helpTooltip}>
        <QuestionCircleOutlined style={{ color: '#999', cursor: 'help', fontSize: '14px' }} />
      </Tooltip>
    </Space>
  );

  return (
    <div className="page-container">
      <ListPageHeader
        basePath="/admin"
        items={['data', 'data.inventory_types']}
        title={titleWithHelp}
      />
      <MerchantInventoryTypesList
        merchantId={currentMerchant?.id}
        inventoryTypes={inventoryTypes}
        merchantInventoryTypeService={merchantInventoryTypeService}
        role="admin"
        allowCreate={false}
        hideCardHeader
      />
    </div>
  );
}

export default AdminMerchantInventoryTypesList;
